import React from "react"
import {
  nePasManquerContainer,
  nePasManquerTitle,
  nePasManquerResume,
} from "./ne-pas-manquer.module.scss"
import PropTypes from "prop-types"
import ContentTransformer from "../../Transformers/content-transformer"
import NePasManquerItem from "./NePasManquerItem/ne-pas-manquer-item"
import { useNePasManquer } from "./ne-pas-manquer-query"

//-----------------------Parent component---------------------------//

const ListNePasManquer = () => {
  const data = useNePasManquer()
  if (data.allNodePage.edges.length === 0) {
    return null
  }
  return (
    <>
      <h2 className={nePasManquerTitle}>
        {data.taxonomyTermZoneDefinie.field_label || "À ne pas manquer"}
      </h2>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={nePasManquerResume}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={nePasManquerContainer}>
        <RenderNePasManquer nePasManquerData={data} />
      </div>
    </>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderNePasManquer = ({ nePasManquerData }) => {
  return nePasManquerData.allNodePage.edges.map(({ node }) => {
    return <NePasManquerItem key={node.drupal_id} nePasManquer={node} />
  })
}

//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

RenderNePasManquer.propTypes = {
  nePasManquerData: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default ListNePasManquer
